<template>
    <section class="order-build-section text-end">
        <!-- Right panel -->
        <div
            class="modal fade drawer right-align"
            id="addAnotherItemModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Add Another Item
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/maincss/images/cross.svg" alt="" />
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="search_block">
                            <div class="search-area">
                                <form
                                    data-vv-scope="search-form"
                                    @submit.prevent="searchProducts"
                                    class="search-form-inline"
                                >
                                    <input
                                        type="search"
                                        v-model="listConfig.searchKeyword"
                                        @search="searchProducts"
                                        @input="onSearchText"
                                        placeholder="Search your Product"
                                        aria-label="Search"
                                        name="search"
                                        refs="searchKey"
                                        class="search-form-control"
                                        aria-required="true"
                                        aria-invalid="false"
                                    />
                                    <button type="submit" class="search-btn">
                                        <img
                                            @click="searchProducts"
                                            src="/maincss/images/icons/magnifying-glass.svg"
                                            alt="logo"
                                            class="headerlogo"
                                        />
                                    </button>
                                </form>
                            </div>

                            <div
                                v-if="enableAdvancedSearch"
                                class="select_open collapsed"
                            >
                                <a
                                    data-toggle="collapse"
                                    href="#searchBlock"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="searchBlock"
                                    >ADVANCED SEARCH</a
                                >
                            </div>
                            <div
                                v-if="enableAdvancedSearch"
                                id="searchBlock"
                                class="collapse"
                            >
                                <div class="row">
                                    <div class="col-md-6">
                                        <fieldset class="form-group">
                                            <label class="label2" for=""
                                                >Attribute Sets</label
                                            >
                                            <v-select
                                                label="attribute_set_name"
                                                :reduce="(data) => data.id"
                                                :options="
                                                    all_attribute_sets_list
                                                "
                                                :placeholder="'Attribute Sets'"
                                                v-model="
                                                    listConfig.attribute_set_id
                                                "
                                                @input="getAllAttributes"
                                            ></v-select>
                                        </fieldset>
                                    </div>
                                    <div class="col-md-6">
                                        <fieldset class="form-group">
                                            <label class="label2" for=""
                                                >Attributes</label
                                            >
                                            <v-select
                                                label="attribute_name"
                                                :reduce="(data) => data.id"
                                                :options="all_attributes_list"
                                                v-model="
                                                    listConfig.attribute_id
                                                "
                                                :placeholder="'Attributes'"
                                            ></v-select>
                                        </fieldset>
                                    </div>
                                    <div class="search_button">
                                        <a
                                            @click="getProducts"
                                            href="javascript:void(0)"
                                            class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 ml_20"
                                        >
                                            MODIFY SEARCH
                                        </a>

                                        <a
                                            @click="resetFilter"
                                            href="javascript:void(0)"
                                            class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 ml_20"
                                        >
                                            RESET
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product_details_block">
                            <div class="product_build_details">
                                <h3 class="mb-2">
                                    Search Result:
                                    <span>({{ products.length }})</span>
                                </h3>
                                <span class="border border-dark bg-warning p-1">
                                    Note: Results are limited to the same
                                    decoration method and location chosen
                                </span>
                                <div class="products_list" id="accordion">
                                    <div class="row">
                                        <div
                                            v-for="(product, index) of products"
                                            :key="index"
                                            class="col-md-4 col-sm-6"
                                        >
                                            <div
                                                class="product_description"
                                                :class="{
                                                    collapsed:
                                                        !current_product ||
                                                        current_product.id !=
                                                            product.id
                                                }"
                                                @click="showProduct(product)"
                                            >
                                                <div class="product_img">
                                                    <img
                                                        class="pro-img"
                                                        v-if="
                                                            !product.t_shirt_24_hour
                                                        "
                                                        :src="
                                                            product.product_default_image
                                                        "
                                                    />
                                                    <img
                                                        class="pro-img"
                                                        v-else
                                                        :src="
                                                            product.t_shirt_24_hour_image
                                                        "
                                                    />
                                                    <!-- <span class="discount_label">-86%</span> -->
                                                    <a class="list_target_link"
                                                        ><img
                                                            src="/maincss/images/down_arrow_blue.svg"
                                                            alt=""
                                                    /></a>
                                                </div>
                                                <h4 class="text-center mt-1">
                                                    {{ product.product_number }}
                                                </h4>
                                                <h4 class="title mt-0">
                                                    {{
                                                        product.name.length > 25
                                                            ? product.name.slice(
                                                                  0,
                                                                  25
                                                              ) + "..."
                                                            : product.name
                                                    }}
                                                </h4>
                                                <DisplayProductPrice
                                                    :product="product"
                                                />
                                                <ul
                                                    class="colors"
                                                    v-if="
                                                        !product.t_shirt_24_hour
                                                    "
                                                >
                                                    <li
                                                        v-for="(
                                                            color, color_index
                                                        ) in product.colors"
                                                        :key="
                                                            color.name +
                                                            product.id
                                                        "
                                                        v-show="
                                                            hasLimit(
                                                                product,
                                                                color_index
                                                            )
                                                        "
                                                        :style="
                                                            color.swatches
                                                                ? 'background-image:url(' +
                                                                  color.swatches +
                                                                  ')'
                                                                : 'background-color:' +
                                                                  color.hex
                                                        "
                                                    ></li>
                                                    <li
                                                        class="more_colors"
                                                        v-show="
                                                            product.colors
                                                                .length >
                                                            colors_limit
                                                        "
                                                    >
                                                        <a
                                                            href="javascript:void(0);"
                                                            v-if="
                                                                product.is_color_show_more
                                                            "
                                                            >-</a
                                                        >
                                                        <a
                                                            href="javascript:void(0);"
                                                            v-else
                                                            >+{{
                                                                product.colors
                                                                    .length -
                                                                colors_limit
                                                            }}</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>

                                            <div
                                                class="color_sizes_block collapse"
                                                :class="{
                                                    show:
                                                        current_product &&
                                                        current_product.id ==
                                                            product.id
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        current_product &&
                                                        product.id ==
                                                            current_product.id
                                                    "
                                                >
                                                    <ul
                                                        class="nav nav-tabs overfolw_x_scroll"
                                                        id="myTab"
                                                        role="tablist"
                                                    >
                                                        <li
                                                            @click="
                                                                setActiveGender(
                                                                    index
                                                                )
                                                            "
                                                            class="nav-item"
                                                            :class="{
                                                                active:
                                                                    current_product.active_gender_index ==
                                                                    index
                                                            }"
                                                            v-for="(
                                                                gender, index
                                                            ) in current_product.gender_groups"
                                                            :key="index"
                                                            role="presentation"
                                                        >
                                                            <a
                                                                class="nav-link"
                                                                :id="
                                                                    index +
                                                                    '-tab'
                                                                "
                                                                role="tab"
                                                                aria-controls="profile"
                                                                aria-selected="false"
                                                                >{{
                                                                    gender.gender
                                                                }}</a
                                                            >
                                                        </li>
                                                    </ul>
                                                    <div
                                                        v-for="(
                                                            gender, gender_index
                                                        ) in current_product.gender_groups"
                                                        :key="gender_index"
                                                    >
                                                        <div
                                                            v-if="
                                                                gender_index ==
                                                                current_product.active_gender_index
                                                            "
                                                        >
                                                            <div
                                                                class="col-md-12 color_checkboxes_mr"
                                                            >
                                                                <h4
                                                                    class="available_colors font_size_17 mt_20 mb_0"
                                                                >
                                                                    Available
                                                                    Colors
                                                                </h4>
                                                                <div
                                                                    class="d-flex flex-wrap justify-content-left color_checkbox"
                                                                >
                                                                    <div
                                                                        v-for="(
                                                                            color,
                                                                            color_index
                                                                        ) in gender.available_colors"
                                                                        :key="
                                                                            color_index
                                                                        "
                                                                        class="form-check pl-0 mt_10"
                                                                    >
                                                                        <label
                                                                            v-show="
                                                                                color_index <=
                                                                                9
                                                                            "
                                                                            class="checkbox_custom"
                                                                            :class="{
                                                                                'checkmark-black':
                                                                                    color.is_selected &&
                                                                                    color.hash ==
                                                                                        '#ffffff',
                                                                                'check-active':
                                                                                    color.is_selected &&
                                                                                    color.hash !=
                                                                                        '#ffffff'
                                                                            }"
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                :id="`gender_${gender.id}_color_${color.id}`"
                                                                                :name="
                                                                                    'avilable_color_' +
                                                                                    color_index
                                                                                "
                                                                                @change="
                                                                                    getsizeByColor(
                                                                                        color,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                                :disabled="
                                                                                    color.disabled
                                                                                "
                                                                                v-tooltip="
                                                                                    color.disabled
                                                                                        ? `${color.color_name} already added in build`
                                                                                        : undefined
                                                                                "
                                                                                v-model="
                                                                                    color.is_selected
                                                                                "
                                                                            />
                                                                            <span
                                                                                v-if="
                                                                                    color.hash
                                                                                "
                                                                                :class="
                                                                                    color.hash.trim() ==
                                                                                    '#ffffff'
                                                                                        ? 'checkmark checkmark_black'
                                                                                        : 'checkmark'
                                                                                "
                                                                                v-bind:style="
                                                                                    'background:' +
                                                                                    color.hash
                                                                                "
                                                                            ></span>
                                                                            <img
                                                                                v-else
                                                                                :src="
                                                                                    color.swatches
                                                                                "
                                                                                class="checkmark"
                                                                                :class="[
                                                                                    color.hash ==
                                                                                    '#FFFFFF'
                                                                                        ? 'bg-white'
                                                                                        : ''
                                                                                ]"
                                                                            />
                                                                        </label>

                                                                        <label
                                                                            v-show="
                                                                                current_product.is_color_show_more &&
                                                                                color_index >
                                                                                    9
                                                                            "
                                                                            class="checkbox_custom"
                                                                            :class="{
                                                                                'checkmark-black':
                                                                                    color.is_selected &&
                                                                                    color.hash ==
                                                                                        '#ffffff',
                                                                                'check-active':
                                                                                    color.is_selected &&
                                                                                    color.hash !=
                                                                                        '#ffffff'
                                                                            }"
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                :id="`gender_${gender.id}_color_${color.id}`"
                                                                                :name="
                                                                                    'avilable_color_' +
                                                                                    index
                                                                                "
                                                                                @change="
                                                                                    getsizeByColor(
                                                                                        color,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                                v-model="
                                                                                    color.is_selected
                                                                                "
                                                                            />
                                                                            <span
                                                                                v-if="
                                                                                    color.hash
                                                                                "
                                                                                :class="
                                                                                    color.hash.trim() ==
                                                                                    '#ffffff'
                                                                                        ? 'checkmark checkmark_black'
                                                                                        : 'checkmark'
                                                                                "
                                                                                v-bind:style="
                                                                                    'background:' +
                                                                                    color.hash
                                                                                "
                                                                            ></span>
                                                                            <img
                                                                                v-else
                                                                                :src="
                                                                                    color.swatches
                                                                                "
                                                                                class="checkmark"
                                                                                :class="[
                                                                                    color.hash ==
                                                                                    '#FFFFFF'
                                                                                        ? 'bg-white'
                                                                                        : ''
                                                                                ]"
                                                                            />
                                                                        </label>
                                                                    </div>

                                                                    <div
                                                                        v-show="
                                                                            gender
                                                                                .available_colors
                                                                                .length >
                                                                            10
                                                                        "
                                                                        class="form-check pl-0 mt_10"
                                                                    >
                                                                        <label
                                                                            class="checkbox_custom"
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                @click="
                                                                                    showMoreColors
                                                                                "
                                                                            />
                                                                            <span
                                                                                class="checkmark check_box plus_icon-align"
                                                                                v-bind:class="
                                                                                    current_product.is_color_show_more
                                                                                        ? 'minus_box'
                                                                                        : ''
                                                                                "
                                                                            >
                                                                                <img
                                                                                    v-if="
                                                                                        current_product.is_color_show_more
                                                                                    "
                                                                                    src="/maincss/images/minus1.svg"
                                                                                />
                                                                                <template
                                                                                    v-else
                                                                                    >+{{
                                                                                        gender
                                                                                            .available_colors
                                                                                            .length -
                                                                                        10
                                                                                    }}</template
                                                                                >
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <ProductSizeQuantityInputs
                                                                ref="productSizeQuantity"
                                                                :product="
                                                                    current_product
                                                                "
                                                                :build-details="
                                                                    buildDetails
                                                                "
                                                                :getMarkupFromTier="
                                                                    getMarkupFromTier
                                                                "
                                                                @updateParentDom="
                                                                    $forceUpdate()
                                                                "
                                                                @deleteColor="
                                                                    getsizeByColor
                                                                "
                                                            />
                                                            <div
                                                                class="col-md-12"
                                                            >
                                                                <div
                                                                    class="d-md-flex mt_26 cost_total_col"
                                                                >
                                                                    <div
                                                                        class="quantity d-flex align-items-center"
                                                                    >
                                                                        <h4
                                                                            class="font_size_22 mb-0"
                                                                        >
                                                                            Quantity
                                                                        </h4>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-if="
                                                                                current_product &&
                                                                                product_loaded
                                                                            "
                                                                        >
                                                                            {{
                                                                                gender.total_qty_gender_wise
                                                                            }}
                                                                        </h3>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-else
                                                                        >
                                                                            0
                                                                        </h3>
                                                                    </div>
                                                                    <div
                                                                        class="quantity d-flex align-items-center"
                                                                        v-if="
                                                                            total_build_quantity >
                                                                            0
                                                                        "
                                                                    >
                                                                        <h4
                                                                            class="font_size_22 mb-0"
                                                                        >
                                                                            Build
                                                                            Quantity
                                                                        </h4>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-if="
                                                                                current_product &&
                                                                                product_loaded
                                                                            "
                                                                        >
                                                                            {{
                                                                                total_build_quantity
                                                                            }}
                                                                        </h3>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-else
                                                                        >
                                                                            0
                                                                        </h3>
                                                                    </div>
                                                                    <div
                                                                        class="quantity d-flex align-items-center ml_16"
                                                                    >
                                                                        <h4
                                                                            class="font_size_22 mb-0"
                                                                        >
                                                                            Total
                                                                            Cost
                                                                        </h4>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-if="
                                                                                current_product &&
                                                                                product_loaded
                                                                            "
                                                                        >
                                                                            {{
                                                                                icPriceFormat(
                                                                                    gender.total_cost_gender_wise
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                        <h3
                                                                            class="font_size_35 mb-0 ml_10"
                                                                            v-else
                                                                        >
                                                                            {{
                                                                                icPriceFormat(
                                                                                    0
                                                                                )
                                                                            }}
                                                                        </h3>

                                                                        <div
                                                                            class="dropdown"
                                                                            v-if="
                                                                                showBreakupCharges(
                                                                                    gender
                                                                                )
                                                                            "
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0);"
                                                                                class="dropdown-toggle d-flex align-items-center"
                                                                                :id="'dropdownCostButton'"
                                                                                data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <img
                                                                                    src="/maincss/images/path.png"
                                                                                    class="ml_6 path"
                                                                                />
                                                                            </a>

                                                                            <div
                                                                                class="dropdown-menu drop-cart-menu drop_product"
                                                                                aria-labelledby="dropdownCostButton"
                                                                            >
                                                                                <h4
                                                                                    class="font_size_16 text_primary_blue py_2 px_20"
                                                                                >
                                                                                    Cost
                                                                                    <span
                                                                                        class="cross_ic"
                                                                                    >
                                                                                        <img
                                                                                            src="/maincss/images/cross.svg"
                                                                                        />
                                                                                    </span>
                                                                                </h4>
                                                                                <div
                                                                                    class="scroll"
                                                                                >
                                                                                    <div
                                                                                        class="dropdown-item d-flex align-items-center"
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-25"
                                                                                        >
                                                                                            Sub
                                                                                            Total:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto"
                                                                                        >
                                                                                            {{
                                                                                                icPriceFormat(
                                                                                                    gender.subtotal
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        class="dropdown-item d-flex align-items-center"
                                                                                        v-if="
                                                                                            gender.total_design_fee
                                                                                        "
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-25"
                                                                                        >
                                                                                            Design
                                                                                            Fee:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto"
                                                                                        >
                                                                                            {{
                                                                                                gender.total_design_fee
                                                                                                    ? icPriceFormat(
                                                                                                          gender.total_design_fee
                                                                                                      )
                                                                                                    : 0.0
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div
                                                                                        class="dropdown-item d-flex align-items-center"
                                                                                        v-if="
                                                                                            gender.total_discount_value
                                                                                        "
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-25"
                                                                                        >
                                                                                            Discount:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto"
                                                                                        >
                                                                                            -
                                                                                            {{
                                                                                                gender.total_discount_value
                                                                                                    ? icPriceFormat(
                                                                                                          gender.total_discount_value
                                                                                                      )
                                                                                                    : icPriceFormat(
                                                                                                          0.0
                                                                                                      )
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <p
                                                                    class="base_content"
                                                                    v-if="
                                                                        current_product.decoration_type ==
                                                                        1
                                                                    "
                                                                >
                                                                    *Base price
                                                                    includes
                                                                    1-color
                                                                    imprint in
                                                                    1-location
                                                                    up to size
                                                                    XL. Larger
                                                                    sizes may
                                                                    incur
                                                                    additional
                                                                    costs.
                                                                    Customize
                                                                    further to
                                                                    see
                                                                    additional
                                                                    pricing.
                                                                </p>
                                                                <p
                                                                    class="base_content"
                                                                    v-if="
                                                                        current_product.decoration_type ==
                                                                        2
                                                                    "
                                                                >
                                                                    *Pricing
                                                                    includes
                                                                    embroidery
                                                                    up to 8,000
                                                                    stitches in
                                                                    1-location
                                                                    up to size
                                                                    XL. Larger
                                                                    sizes may
                                                                    incur
                                                                    additional
                                                                    costs.
                                                                    +$0.50 per
                                                                    additional
                                                                    1,000
                                                                    stitches
                                                                    over 8,000.
                                                                </p>
                                                                <a
                                                                    @click="
                                                                        addItemToDesign
                                                                    "
                                                                    href="javascript:void(0);"
                                                                    class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 mt_10"
                                                                >
                                                                    ADD ITEM
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-sm-12 mt-1 text-center"
                                        >
                                            <!-- <div class="product_description"> -->
                                            <h5 v-if="products.length == 0">
                                                {{ notFoundMessage }}
                                            </h5>
                                            <!-- </div> -->
                                        </div>
                                    </div>
                                    <div
                                        class="load_more"
                                        v-if="
                                            total_products_count >
                                            listConfig.limit
                                        "
                                    >
                                        <a
                                            @click="loadMoreProducts"
                                            href="javascript:void(0);"
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr_20"
                                        >
                                            LOAD MORE
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        <!-- Right panel end -->
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </section>
</template>
<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import ProductSizeQuantityInputs from "@/components/build/V3/ProductSizeQuantityInputs";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
export default {
    name: "SearchProducts",
    components: { ProductSizeQuantityInputs, DisplayProductPrice },
    props: {
        buildDetails: {
            type: Object,
            required: true
        },
        vendorColorsList: {
            type: Array,
            required: true,
            default: () => {}
        },
        decorationColors: {
            type: Object,
            required: true,
            default: () => {}
        },
        nonStandardColorObj: {
            type: Object
        },
        getMarkupFromTier: {
            type: Function,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            product_loaded: false,
            products: [],
            total_products_count: 0,
            colors_limit: 6,
            total_build_quantity: 0,
            listConfig: {
                limit: 15,
                category_id: null,
                category_ids: [],
                print_area_ids: [],
                attribute_id: null,
                attribute_set_id: null,
                decoration_type: null,
                decoration_price_template: null,
                searchKeyword: "",
                excluded_ids: [],
                attributes: [
                    "id",
                    "product_number",
                    "name",
                    "color_ids",
                    "lowest_base_price",
                    "price_base",
                    "price_markup_value",
                    "product_default_image",
                    "decoration_price_type",
                    "decoration_type",
                    "decoration_price_template",
                    "price_color_category_dark",
                    "price_color_category_light",
                    "price_decoration_bulk",
                    "t_shirt_24_hour",
                    "t_shirt_24_hour_image"
                ]
            },
            all_colors_list: [],
            all_category_list: [],
            all_attributes_list: [],
            all_attribute_sets_list: [],
            all_print_areas: [],
            isLoader: false,
            current_product: null,
            tshirt_size_orders: [
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "XXL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL",
                "7XL",
                "8XL",
                "9XL",
                "10XL",
                "11XL",
                "12XL",
                "13XL",
                "14XL",
                "OSFM",
                "YXS",
                "YS",
                "YM",
                "YL",
                "YXL",
                "1T",
                "2T",
                "3T",
                "4T",
                "5T",
                "6T"
            ],
            imprint_colors_array_for_template: [],
            enableAdvancedSearch: false,
            notFoundMessage: ""
        };
    },
    computed: {
        ...mapGetters(["printTemplates", "embroideryTemplates"])
    },
    methods: {
        async openModal() {
            this.product_loaded = false;
            this.current_product = null;
            if (this.all_colors_list.length == 0) {
                this.getAllColors();
            }

            if (this.all_print_areas.length == 0) {
                await this.getAllPrintAreas();
            }

            this.listConfig.attribute_id = null;
            this.listConfig.searchKeyword = "";

            // Exclude items
            if (this.buildDetails.OrderBuildItems) {
                // Print Area ids
                this.listConfig.print_area_ids = [];
                this.listConfig.excluded_ids = [];
                let product_ids = {};
                this.buildDetails.OrderBuildItems.forEach(
                    (item, item_index) => {
                        if (item_index == 0) {
                            this.listConfig.decoration_type =
                                item.NewProduct.decoration_type;
                            this.listConfig.decoration_price_template =
                                item.NewProduct.decoration_price_template;
                            this.listConfig.t_shirt_24_hour =
                                item.t_shirt_24_hour;
                        }
                        let currentPrintArea = this.all_print_areas.find(
                            (printArea) =>
                                printArea.id == item.NewProduct.product_type_id
                        );
                        if (currentPrintArea) {
                            if (!currentPrintArea.parent_print_area) {
                                this.listConfig.print_area_ids.push(
                                    currentPrintArea.id
                                );
                                this.all_print_areas.forEach((area) => {
                                    if (
                                        area.parent_print_area ==
                                        currentPrintArea.id
                                    ) {
                                        this.listConfig.print_area_ids.push(
                                            area.id
                                        );
                                    }
                                });
                            } else {
                                let parentPrintArea = this.all_print_areas.find(
                                    (printArea) =>
                                        printArea.id ==
                                        currentPrintArea.parent_print_area
                                );
                                if (parentPrintArea) {
                                    this.listConfig.print_area_ids.push(
                                        parentPrintArea.id
                                    );
                                    this.all_print_areas.forEach((area) => {
                                        if (
                                            area.parent_print_area ==
                                            parentPrintArea.id
                                        ) {
                                            this.listConfig.print_area_ids.push(
                                                area.id
                                            );
                                        }
                                    });
                                }
                            }
                        }

                        if (product_ids[item.product_id]) {
                            product_ids[item.product_id].push(item);
                        } else {
                            product_ids[item.product_id] = [item];
                        }
                    }
                );

                for (const [id, colors] of Object.entries(product_ids)) {
                    let color_ids = colors[0].NewProduct.color_ids
                        ? JSON.parse(colors[0].NewProduct.color_ids)
                        : [];
                    if (
                        colors.length == color_ids.length ||
                        colors[0].t_shirt_24_hour
                    ) {
                        this.listConfig.excluded_ids.push(id);
                    }
                }

                this.listConfig.print_area_ids = [
                    ...new Set(this.listConfig.print_area_ids)
                ];
            }
            this.getProducts();

            this.total_build_quantity = 0;
            this.buildDetails.OrderBuildItems.forEach((item) => {
                this.total_build_quantity += parseInt(
                    item.color_data.total_quantity
                );
            });
            /* eslint-disable */
            $("#addAnotherItemModal").modal("show");
            /* eslint-enable */
        },
        loadMoreProducts() {
            this.listConfig.limit += 15;
            this.getProducts();
        },
        resetFilter() {
            this.listConfig.category_id = null;
            this.listConfig.attribute_id = null;
            this.listConfig.attribute_set_id = null;
            this.listConfig.searchKeyword = "";
            this.getAllAttributeSets();
            this.getAllAttributes();
            this.getProducts();
        },
        onChangeCategoryFilter() {
            this.listConfig.attribute_id = null;
            this.listConfig.attribute_set_id = null;
            this.getAllAttributeSets();
            this.getAllAttributes();
        },
        onSearchText() {
            if (
                !this.listConfig.searchKeyword ||
                this.listConfig.searchKeyword.trim().length == 0
            ) {
                this.getProducts();
            }
        },
        searchProducts() {
            const buildItemProductSkus = this.buildDetails.OrderBuildItems.map(
                (item) => item.NewProduct.product_number.toLowerCase()
            );
            this.getProducts().then(() => {
                if (this.products.length == 0) {
                    if (
                        buildItemProductSkus.includes(
                            this.listConfig.searchKeyword.trim().toLowerCase()
                        )
                    ) {
                        this.notFoundMessage =
                            "This item already added in build.";
                    } else {
                        this.notFoundMessage = "No records found.";
                    }
                }
            });
        },
        getProducts() {
            this.notFoundMessage = "";
            this.isLoader = true;
            return new Promise((resolve, reject) => {
                ApiService.post("/products", this.listConfig)
                    .then(({ data }) => {
                        this.total_products_count = data.products.count;
                        this.products = data.products.rows;
                        this.products.forEach((product) => {
                            let color_ids = product.color_ids
                                ? JSON.parse(product.color_ids)
                                : [];
                            product.colors = this.all_colors_list.filter(
                                (color) => color_ids.includes(color.id)
                            );

                            if (product.t_shirt_24_hour) {
                                product.NewSubProducts =
                                    product.NewSubProducts.filter(
                                        (sub_product_data) =>
                                            sub_product_data.Color.name ==
                                            "White"
                                    );
                            }

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        console.log(err);
                        reject(err);
                    });
            });
        },
        showProduct(product) {
            this.product_loaded = false;
            if (this.current_product && this.current_product.id == product.id) {
                this.current_product = null;
                return;
            }

            this.getProduct(product.id);
        },
        getProduct(productId) {
            this.current_product = null;
            return new Promise((resolve, reject) => {
                this.isLoader = true;
                ApiService.get("/home-single-newproduct/" + productId)
                    .then(async ({ data }) => {
                        this.current_product = data.product;

                        this.current_product.NewSubProducts.sort(
                            this.compareBySize
                        );

                        this.current_product.is_color_show_more = false;
                        this.current_product.available_colors = [];
                        this.current_product.gender_groups = [];
                        this.current_product.more_decoration =
                            JSON.parse(this.current_product.more_decoration) ||
                            [];
                        this.current_product.decoration_price_template_values_for_imprint =
                            [];
                        this.current_product.decoration_price_template_values =
                            [];
                        this.current_product.decoration_price_template_location2 =
                            [];
                        this.current_product.active_gender_index = 0;
                        this.current_product.design_fee = 0;

                        if (
                            this.current_product.decoration_price_type ==
                            "global_price"
                        ) {
                            if (this.current_product.decoration_type == 1) {
                                let decoration_price_template =
                                    this.printTemplates.find(
                                        (template) =>
                                            template.id ==
                                            this.current_product
                                                .decoration_price_template
                                    );
                                if (decoration_price_template) {
                                    this.current_product.PrintTemplate =
                                        decoration_price_template;
                                    this.current_product.price_color_category_dark =
                                        decoration_price_template.price_dark;
                                    this.current_product.price_color_category_light =
                                        decoration_price_template.price_light;
                                    this.current_product.price_decoration_bulk =
                                        JSON.stringify({
                                            print_location1:
                                                decoration_price_template.PrintLocation1Templates,
                                            print_location2:
                                                decoration_price_template.PrintLocation2Templates
                                        });
                                }
                            } else if (
                                this.current_product.decoration_type == 2
                            ) {
                                let decoration_price_template =
                                    this.embroideryTemplates.find(
                                        (template) =>
                                            template.id ==
                                            this.current_product
                                                .decoration_price_template
                                    );
                                if (decoration_price_template) {
                                    this.current_product.EmbroideryTemplate =
                                        decoration_price_template;
                                    this.current_product.price_color_category_dark =
                                        decoration_price_template.price_dark;
                                    this.current_product.price_color_category_light =
                                        decoration_price_template.price_light;
                                    this.current_product.price_decoration_bulk =
                                        JSON.stringify(
                                            decoration_price_template.EmbroideryQuantities
                                        );
                                }
                            }
                        }

                        if (this.current_product.t_shirt_24_hour) {
                            this.current_product.NewSubProducts =
                                this.current_product.NewSubProducts.filter(
                                    (sub_product_data) =>
                                        sub_product_data.Color.name == "White"
                                );
                        }

                        let availableColors = this.groupArrayOfObjects(
                            this.current_product.NewSubProducts,
                            "color_id"
                        );
                        Object.values(availableColors).forEach((color) => {
                            let item_color =
                                this.buildDetails.OrderBuildItems.find(
                                    (item) =>
                                        item.product_id == productId &&
                                        item.color_id == color[0].Color.id
                                );

                            let lowest_price = 0;
                            color.forEach((size, i) => {
                                let base_price = size.price_base
                                    ? size.price_base
                                    : 0;
                                if (parseFloat(base_price) > 0) {
                                    if (i == 0) {
                                        lowest_price = parseFloat(base_price);
                                    } else if (
                                        parseFloat(lowest_price) >
                                        parseFloat(base_price)
                                    ) {
                                        lowest_price = parseFloat(base_price);
                                    }
                                }
                            });
                            this.current_product.available_colors.push({
                                id: color[0].Color.id,
                                color_name: color[0].Color.name,
                                hash: color[0].Color.hex,
                                pms: color[0].Color.pms,
                                swatches: color[0].Color.swatches,
                                shades: color[0].Color.shades,
                                category: color[0].Color.category,
                                default_selection: color[0].default_selection,
                                is_selected: false,
                                disabled: item_color ? true : false,
                                price_base: lowest_price
                            });
                        });

                        this.loadVendorColors(this.current_product);

                        await this.getMoreDecorations(
                            this.current_product.more_decoration
                        );

                        await this.getProductImages(this.current_product);

                        this.prepareDecorationPrices(
                            this.current_product.decoration_type,
                            JSON.parse(
                                this.current_product.price_decoration_bulk
                            )
                        );

                        var gendersGroup =
                            JSON.parse(this.current_product.size_groupings) ||
                            [];
                        await this.getGendersGroups(gendersGroup);

                        this.current_product.gender_groups.forEach((gender) => {
                            gender.available_colors = JSON.parse(
                                JSON.stringify(
                                    this.current_product.available_colors
                                )
                            );
                        });

                        // STORE DEFAULT COLOR
                        let default_selected_color =
                            this.current_product.available_colors.find(
                                (color) => color.default_selection == 1
                            );
                        if (this.current_product.t_shirt_24_hour) {
                            default_selected_color =
                                this.current_product.available_colors.find(
                                    (color) => color.color_name === "White"
                                );
                        }

                        this.current_product.price_base =
                            default_selected_color.price_base;
                        this.current_product.price_markup_value =
                            (parseFloat(this.current_product.price_base) *
                                parseFloat(
                                    this.current_product.price_markup_percentage
                                )) /
                            100;

                        if (default_selected_color) {
                            setTimeout(() => {
                                document
                                    .getElementById(
                                        `gender_${
                                            this.current_product.gender_groups[
                                                this.current_product
                                                    .active_gender_index
                                            ].id
                                        }_color_${default_selected_color.id}`
                                    )
                                    .click();
                            }, 300);
                        }

                        this.product_loaded = true;
                        this.$forceUpdate();

                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        console.log(err);
                        reject(err);
                    });
            });
        },
        getGendersGroups(gendersGroup) {
            return new Promise((resolve, reject) => {
                ApiService.post("/gender-age-sizes-byIds/", gendersGroup)
                    .then(({ data }) => {
                        if (data.success == true) {
                            data.genderagesize.forEach((elem) => {
                                let allsizes = [];
                                let usizes = [];
                                let sizes = JSON.parse(elem.sizes);
                                this.current_product.NewSubProducts.forEach(
                                    (elm) => {
                                        if (sizes.includes(elm.size_id)) {
                                            if (
                                                !allsizes.find(
                                                    (s) =>
                                                        s.size_id == elm.size_id
                                                )
                                            ) {
                                                usizes.push(elm);
                                            }
                                            allsizes.push(elm);
                                        }
                                    }
                                );

                                if (allsizes.length > 0) {
                                    this.current_product.gender_groups.push({
                                        id: elem.id,
                                        prod_type_id: elem.prod_type_id,
                                        gender: elem.gender,
                                        total_cost_gender_wise: 0,
                                        total_qty_gender_wise: 0,
                                        total_cost: 0,
                                        sizes: allsizes,
                                        selected_colors: []
                                    });
                                }
                            });
                        } else {
                            this.$toast.error(data.error, {
                                position: "top-right"
                            });
                        }
                        resolve(data);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        getsizeByColor(color_obj, event = null) {
            let active_gender =
                this.current_product.gender_groups[
                    this.current_product.active_gender_index
                ];
            active_gender = JSON.parse(JSON.stringify(active_gender));
            if (!event || !event.target.checked) {
                let selected_colors = active_gender["selected_colors"];
                if (selected_colors && selected_colors.length) {
                    active_gender["selected_colors"] = selected_colors.filter(
                        (color) => color.id != color_obj.id
                    );
                    let color_index = active_gender.available_colors.findIndex(
                        (color) => color.id == color_obj.id
                    );
                    active_gender.available_colors[
                        color_index
                    ].is_selected = false;
                }
                this.$refs.productSizeQuantity[0].calculatePricing(
                    this.current_product.active_gender_index
                );
                this.current_product.gender_groups[
                    this.current_product.active_gender_index
                ] = active_gender;

                this.$refs.productSizeQuantity[0].$forceUpdate();
                this.$forceUpdate();
                return;
            }

            this.current_product.selected_color = color_obj;
            let sizes = [];
            sizes.push(
                active_gender.sizes.filter(function (size) {
                    return size.color_id === color_obj.id;
                })
            );
            let sizesby_selected_color = [].concat.apply([], sizes);
            let new_sizeby_selected_color_array = [];
            sizesby_selected_color.forEach((element) => {
                if (element.status) {
                    element.sub_product_id = element.id;
                    new_sizeby_selected_color_array.push(element);
                }
            });

            let colorObj = JSON.parse(JSON.stringify(color_obj));
            colorObj["unique_sizes"] = JSON.parse(
                JSON.stringify(new_sizeby_selected_color_array)
            );
            colorObj["total_cost_gender_wise"] = 0;
            colorObj["total_qty_gender_wise"] = 0;
            colorObj["total_color_fee"] = 0;
            colorObj["total_dark_category_fee"] = 0;
            colorObj["total_light_category_fee"] = 0;
            if (!active_gender["selected_colors"]) {
                active_gender["selected_colors"] = [colorObj];
            } else {
                let color_index = active_gender["selected_colors"].findIndex(
                    (color) => color.id == colorObj.id
                );
                if (color_index < 0) {
                    active_gender["selected_colors"].push(colorObj);
                }
            }

            this.current_product.gender_groups[
                this.current_product.active_gender_index
            ] = active_gender;

            this.$refs.productSizeQuantity[0].calculatePricing(
                this.current_product.active_gender_index
            );
            this.$refs.productSizeQuantity[0].$forceUpdate();
            this.$forceUpdate();
        },
        prepareDecorationPrices(decoration_type, price_decoration_bulk) {
            this.current_product.price_decoration_bulk = price_decoration_bulk;
            if (decoration_type == 1) {
                let noOfColorsCount =
                    this.current_product.PrintTemplate.no_of_colors;
                if (this.current_product.PrintTemplate.discount_enable) {
                    price_decoration_bulk.print_location1.forEach((row) => {
                        for (let i = 1; i < noOfColorsCount; i++) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
                this.current_product.decoration_price_template_values_for_imprint =
                    price_decoration_bulk.print_location1;
                this.current_product.decoration_price_template_values =
                    price_decoration_bulk.print_location1;
                this.current_product.decoration_price_template_location2 =
                    price_decoration_bulk.print_location2;
            } else if (decoration_type == 2) {
                this.current_product.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.current_product.decoration_price_template_values =
                    price_decoration_bulk;
            } else if (decoration_type == 3) {
                this.current_product.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.current_product.decoration_price_template_values =
                    price_decoration_bulk;
            }
        },
        getMoreDecorations(more_decoration) {
            return new Promise((resolve, reject) => {
                if (more_decoration) {
                    let decoration_values = more_decoration
                        ? more_decoration
                        : [];
                    let more_decoration_values = {
                        decoration_ids: decoration_values
                    };
                    ApiService.post(
                        "/home-decoration-values",
                        more_decoration_values
                    )
                        .then(({ data }) => {
                            this.current_product.more_decoration_list =
                                data.decoration;
                            this.current_product.more_decoration_list.forEach(
                                (decoration) => {
                                    this.current_product.design_fee +=
                                        parseFloat(decoration.price);
                                }
                            );
                            this.current_product.design_fee = parseFloat(
                                parseFloat(
                                    this.current_product.design_fee
                                ).toFixed(2)
                            );
                            resolve(data);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                }
                resolve();
            });
        },
        loadVendorColors(product) {
            this.imprint_colors_array_for_template = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }
                // Added Colors
                if (vendorColors.length > 0) {
                    for (const color of vendorColors) {
                        if (!color.Color) {
                            continue;
                        }
                        let colorsData = {
                            color_id: color.color_id,
                            color_name: color.Color.name,
                            color_pms: color.Color.pms,
                            decor_upcharge: color.decor_upcharge,
                            color_value: color.Color.hex,
                            swatches: color.Color.swatches,
                            category: color.Color.category,
                            shades: color.Color.shades
                                ? JSON.parse(color.Color.shades)
                                : []
                        };

                        if (
                            color.Color.type == "ink" &&
                            product.decoration_type == 1
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "thread" &&
                            product.decoration_type == 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "vinyl" &&
                            product.decoration_type != 1 &&
                            product.decoration_type != 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        }
                    }
                    // Added new color Data in Product objects
                    if (product.Vendor) {
                        product.Vendor.newVendorColors =
                            this.imprint_colors_array_for_template;
                    }
                } else if (product.Vendor) {
                    let vendor_colors = product.Vendor.vendor_colors
                        ? JSON.parse(product.Vendor.vendor_colors)
                        : [];

                    if (product.decoration_type == 1) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_ink;
                    } else if (product.decoration_type == 2) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_thread;
                    } else {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_vinyl;
                    }
                }
            }
        },
        getProductImages(product) {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-product-images/" + product.id)
                    .then(({ data }) => {
                        product.NewProductImages = data.product_images;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        showMoreColors() {
            this.current_product.is_color_show_more =
                !this.current_product.is_color_show_more;
            this.$forceUpdate();
        },
        addItemToDesign() {
            let cart = [];

            let minimum_quantity;
            let gender_total_quantity = 0;
            this.current_product.gender_groups.forEach((csq) => {
                gender_total_quantity += parseInt(csq.total_qty_gender_wise);
            });
            if (this.current_product.decoration_type == 1) {
                minimum_quantity =
                    this.current_product.decoration_price_template_values[0]
                        .quantity;
            } else if (this.current_product.decoration_type == 2) {
                minimum_quantity =
                    this.current_product.decoration_price_template_values[0]
                        .quantity1;
            }

            if (gender_total_quantity == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return;
            } else if (
                parseInt(gender_total_quantity) +
                    parseInt(this.total_build_quantity) <
                parseInt(minimum_quantity)
            ) {
                this.$toast.error(
                    "Quantity should be greater than " + minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let new_canvas_elements = {};
            let canvas_design_colors = {};
            if (this.buildDetails) {
                new_canvas_elements["products_id"] = this.current_product.id;
                new_canvas_elements["first_build_item_id"] =
                    this.buildDetails.OrderBuildItems[0]["id"];
                new_canvas_elements["build_id"] = this.buildDetails.id;
                new_canvas_elements["showNameNumber"] =
                    this.buildDetails.OrderBuildItems[0].name_and_number_json
                        .length > 0;

                if (this.buildDetails.front_design) {
                    new_canvas_elements["front"] =
                        this.buildDetails.front_design;
                }

                if (this.buildDetails.back_design) {
                    new_canvas_elements["back"] = this.buildDetails.back_design;
                }

                if (this.buildDetails.left_design) {
                    new_canvas_elements["left"] = this.buildDetails.left_design;
                }

                if (this.buildDetails.right_design) {
                    new_canvas_elements["right"] =
                        this.buildDetails.right_design;
                }

                if (this.buildDetails.distress_images) {
                    new_canvas_elements["distress_images"] = JSON.parse(
                        this.buildDetails.distress_images
                    );
                }
                if (this.buildDetails.front_color) {
                    canvas_design_colors["front"] = JSON.parse(
                        this.buildDetails.front_color
                    ).map((col) => col.hex);
                }

                if (this.buildDetails.back_color) {
                    canvas_design_colors["back"] = JSON.parse(
                        this.buildDetails.back_color
                    ).map((col) => col.hex);
                }

                if (this.buildDetails.left_color) {
                    canvas_design_colors["left"] = JSON.parse(
                        this.buildDetails.left_color
                    ).map((col) => col.hex);
                }

                if (this.buildDetails.right_color) {
                    canvas_design_colors["right"] = JSON.parse(
                        this.buildDetails.right_color
                    ).map((col) => col.hex);
                }
            }

            let imprint_locations = JSON.parse(
                JSON.stringify(
                    this.buildDetails.OrderBuildItems[0].color_data
                        .imprint_locations
                )
            );
            imprint_locations.forEach((location) => {
                location.colors = [];
                location.no_of_color = 0;
                if (canvas_design_colors[location.location.toLowerCase()]) {
                    canvas_design_colors[
                        location.location.toLowerCase()
                    ].forEach((colorHex) => {
                        let vendorColor = this.vendorColorsList.find(
                            (vendColor) =>
                                vendColor.color_value.toLowerCase() ==
                                colorHex.toLowerCase()
                        );
                        location.colors.push({
                            color: vendorColor || this.nonStandardColorObj,
                            total_decor_upcharge: 0
                        });
                    });

                    location.no_of_color =
                        canvas_design_colors[
                            location.location.toLowerCase()
                        ].length;
                }
                location.price = 0;
                location.total_decoration_fee = 0;
                location.total_price = 0;
            });

            let additionalBuildItems = 0;
            this.current_product.gender_groups.forEach((gender) => {
                if (gender.total_qty_gender_wise > 0) {
                    let selected_colors = [];

                    gender["selected_colors"].forEach((color) => {
                        let quantity = color["unique_sizes"].find(
                            (size) => size.quantity > 0
                        );
                        if (quantity) {
                            additionalBuildItems++;
                            let sizes = [];
                            color["unique_sizes"].forEach((size) => {
                                sizes.push({
                                    sub_product_id: size.sub_product_id,
                                    Size: size.Size,
                                    user_id: this.buildDetails.created_by,
                                    single_location_price:
                                        size.single_location_price,
                                    price_base: size.price_base,
                                    markup_price: size.markup_price,
                                    markup_percentage:
                                        this.current_product
                                            .price_markup_percentage,
                                    ink_price: size.ink_price,
                                    discount: size.discount,
                                    cost: size.cost,
                                    quantity: size.quantity,
                                    total_cost: size.total_cost
                                });
                            });

                            selected_colors.push({
                                id: color.id,
                                color_name: color.color_name,
                                hash: color.hash,
                                pms: color.pms,
                                swatches: color.swatches,
                                shades: color.shades,
                                category: color.category,
                                default_selection: 1,
                                is_selected: true,
                                font_color_sizes_name: this.buildDetails
                                    .OrderBuildItems[0].font_color_sizes_name
                                    ? JSON.parse(
                                          this.buildDetails.OrderBuildItems[0]
                                              .font_color_sizes_name
                                      )
                                    : [],
                                font_color_sizes_number: this.buildDetails
                                    .OrderBuildItems[0].font_color_sizes_number
                                    ? JSON.parse(
                                          this.buildDetails.OrderBuildItems[0]
                                              .font_color_sizes_number
                                      )
                                    : [],
                                selected_name_number:
                                    this.buildDetails.OrderBuildItems[0]
                                        .color_data.selected_name_number ||
                                    null,
                                total_cost_gender_wise:
                                    color.total_cost_gender_wise,
                                total_qty_gender_wise:
                                    color.total_qty_gender_wise,
                                total_color_fee: color.total_color_fee,
                                total_dark_category_fee:
                                    color.total_dark_category_fee,
                                total_light_category_fee:
                                    color.total_light_category_fee,
                                total_discount_value:
                                    color.total_discount_value || 0.0,
                                total_design_fee: color.total_design_fee || 0.0,
                                unique_sizes: sizes,
                                imprint_locations: imprint_locations
                            });
                        }
                    });

                    if (selected_colors.length > 0) {
                        let total_price =
                            parseFloat(gender.total_cost_gender_wise) +
                            parseFloat(
                                this.buildDetails.total_non_standard_fees
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .front_number_fees || 0
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_name_fees || 0
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_number_fees || 0
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .front_number_decor_up_fees || 0
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_name_decor_up_fees || 0
                            ) +
                            parseFloat(
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_number_decor_up_fees || 0
                            );

                        cart.push({
                            item: this.current_product,
                            color: selected_colors[0],
                            colors: selected_colors,
                            gender_name: gender.gender,
                            gender_id: gender.id,
                            base_price: this.current_product.price_base,
                            total_qty: gender.total_qty_gender_wise,
                            subtotal: gender.subtotal,
                            total_cost: total_price,
                            total_design_fee: 0,
                            total_discount_value: 0,
                            total_setup_fee: this.buildDetails.setup_fee,
                            total_front_number_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .front_number_fees,
                            total_back_name_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_name_fees,
                            total_back_number_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_number_fees,
                            total_front_number_decor_up_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .front_number_decor_up_fees,
                            total_back_name_decor_up_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_name_decor_up_fees,
                            total_back_number_decor_up_fees:
                                this.buildDetails.OrderBuildItems[0].color_data
                                    .back_number_decor_up_fees,
                            total_non_standard_fees: 0,
                            total_color_fee: 0,
                            first_build_item_id:
                                this.buildDetails.OrderBuildItems[0]["id"],
                            imprint_locations: imprint_locations
                        });
                    }
                }
            });

            let build_canvas_design_colors = {};

            this.buildDetails.OrderBuildItems.forEach((item) => {
                build_canvas_design_colors[item.id] = {
                    front: item.front_decoration_colors || [],
                    back: item.back_decoration_colors || [],
                    left: item.left_decoration_colors || [],
                    right: item.right_decoration_colors || []
                };
            });

            localStorage.setItem(
                "new_canvas_elements",
                JSON.stringify(new_canvas_elements)
            );
            localStorage.setItem(
                "build_canvas_design_colors",
                JSON.stringify(build_canvas_design_colors)
            );
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(canvas_design_colors)
            );
            localStorage.setItem(
                "total_build_items",
                this.buildDetails.OrderBuildItems.length + additionalBuildItems
            );
            localStorage.setItem("design_build", JSON.stringify(cart));
            localStorage.setItem("is24Tshirt", false);
            localStorage.setItem("colorIndex", 0);
            /* eslint-disable */
            $("#design-confirmation-modal").modal("hide");
            $("#addAnotherItemModal").modal("hide");
            /* eslint-enable */
            this.$router.push({ name: "DesignStudioBuildV3" });
        },
        compareBySize(a, b) {
            const sizeA = this.tshirt_size_orders.indexOf(a.Size.size);
            const sizeB = this.tshirt_size_orders.indexOf(b.Size.size);
            return sizeA - sizeB;
        },
        hasLimit(product, index) {
            if (!product.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },
        showRemainingColors(product, event) {
            event.stopPropagation();
            product.is_color_show_more = !product.is_color_show_more;
            this.$forceUpdate();
        },
        getTotalColorPrice(color) {
            let total_price = 0;

            color.sizes.forEach((size) => {
                if (size.total_price) {
                    total_price += parseFloat(size.total_price);
                }
            });

            return total_price;
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllCategories() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-all-categories-list")
                    .then(({ data }) => {
                        this.all_category_list = data.categories;
                        this.all_category_list.unshift({
                            id: "All",
                            title: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllAttributes() {
            let params = {
                attributes: ["id", "attribute_name"],
                attribute_set_id: this.listConfig.attribute_set_id || undefined
            };
            this.listConfig.attribute_id = null;
            return new Promise((resolve, reject) => {
                ApiService.query("/get-attributes", { params })
                    .then(({ data }) => {
                        this.all_attributes_list = data.attributes;
                        this.all_attributes_list.unshift({
                            id: "All",
                            attribute_name: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllAttributeSets() {
            let params = {
                attributes: ["id", "attribute_set_name"],
                category_ids: this.listConfig.category_ids || undefined
            };
            return new Promise((resolve, reject) => {
                ApiService.query("/get-attribute-sets", { params })
                    .then(({ data }) => {
                        this.all_attribute_sets_list = data.attributes;
                        this.all_attribute_sets_list.unshift({
                            id: "All",
                            attribute_set_name: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllPrintAreas() {
            let params = {
                attributes: ["id", "parent_print_area"]
            };
            return new Promise((resolve, reject) => {
                ApiService.query("/product-types", { params })
                    .then(({ data }) => {
                        this.all_print_areas = data.product_types;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        showBreakupCharges(gender) {
            if (gender.setup_fee > 0) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            }
            return false;
        },
        setActiveGender(index) {
            this.current_product.active_gender_index = index;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        }
    }
};
</script>
